import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import TabsPreview from "@project/components/TabsComponent/TabsComponentPreview";
export const DescriptionTabsItem = {
    label: "Onglet avec description",
    key: "items",
    type: ContentsCustomTypes.DESCRIPTION_TABS_ITEM,
    value: "",
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Enlever image de fond",
            key: "removeBgImage",
            type: ContentsTypes.CHECKBOX,
            value: "",
        },
        {
            label: "Couleur du fond de la section",
            key: "sectionBgColor",
            type: ContentsTypes.COLOR,
            value: "#0000FF",
        },
        {
            label: "Couleur de la bordure",
            key: "borderColor",
            type: ContentsTypes.COLOR,
            value: "#0000FF",
        },
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            label: "",
        },
    ],
};
export const DescriptionTabs = {
    label: "Onglets description",
    type: ContentsCustomTypes.DESCRIPTION_TABS,
    Preview: TabsPreview,
    icon: "list-alt",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Direction",
            key: "direction",
            type: ContentsTypes.RADIO_GROUP,
            value: "horizontal",
            options: [
                { label: "Horizontal", value: "horizontal" },
                { label: "Vertical", value: "vertical" },
            ],
        },
        {
            label: "Style",
            key: "style",
            type: ContentsTypes.RADIO_GROUP,
            value: "text",
            options: [
                { label: "Texte", value: "text" },
                { label: "Contenu", value: "contained" },
            ],
        },
        {
            label: "Couleur",
            key: "color",
            type: ContentsTypes.RADIO_GROUP,
            value: "primary",
            options: [
                { label: "Primaire", value: "primary" },
                { label: "Secondaire", value: "secondary" },
            ],
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [DescriptionTabsItem],
                    value: ContentsCustomTypes.DESCRIPTION_TABS_ITEM,
                },
            ],
        },
    ],
};
